export const alphabet = [
  '#',
  '1',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]

export const ENCOUNTER_TYPES = {
  INITIAL: 'Initial',
  SUBSEQUENT: 'Subsequent',
  OTHER: 'Other',
  DISCHARGE: 'Discharge',
}

export const SIDE_PANEL_TAB_ROW_INDEXES = {
  DX: 0,
  CHARGES: 1,
  FACILITY: 2,
  OTHER: 3,
  QUALITY: 4,
  NOTE: 5,
  HOLD: 6,
}

export const SIDE_PANEL_TAB_COL_INDEXES = {
  MAIN: 0,
  PATIENT: 1,
  HISTORY: 2,
  CLINICAL: 3,
  NOTE: 4,
  AI: 5,
}

export const SYSTEM_ID = '60fc377406250e59f7f0512c'
